import { DataView } from 'primereact/dataview';
import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import CircumstanceDetail from './CircumstanceDetail';
import CircumstanceItem from './CircumstanceItem';
import CircumstanceManager from './CircumstanceManager';

function CircumstancePage({ isActive }) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [circumstanceDetail, setCircumstanceDetail] = useState(undefined);
  const [circumstanceList, setCircumstancelist] = useState([]);
  const [loading, setLoading] = useState(false);
  const { accountContext } = useAccountContext();
  const { openPRNACircumstanceDetail, navigationContext } = useNavigationContext();

  useEffect(() => {
    fetchCircumstanceList();
  }, []);

  const fetchCircumstanceList = async () => {
    await privateFetch('GET', 'prna', `/cu/${accountContext.id}/circumstance/`).then((res) => {
      setCircumstancelist(res);
    });
  };

  const fetchCircumstanceDetail = async () => {
    await privateFetch(
      'GET',
      'prna',
      `/cu/${accountContext.id}/circumstance/${navigationContext.acitveCircumstanceId}/`
    ).then((res) => {
      if (res) setCircumstanceDetail(res);
    });
  };

  const createCircumstance = async (circumstanceForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'prna',
      `/cu/${accountContext.id}/circumstance/`,
      "L'actualité a bien été ajoutée",
      JSON.stringify(circumstanceForm)
    ).then(() => {
      fetchCircumstanceList();
      setLoading(false);
      setPanelIsOpen(false);
      setCircumstanceDetail(undefined);
    });
  };

  const updateCircumstance = async (circumstanceForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/circumstance/${navigationContext.acitveCircumstanceId}/`,
      "L'actualité a bien été modifié",
      JSON.stringify(circumstanceForm)
    ).then(() => {
      fetchCircumstanceList();
      fetchCircumstanceDetail();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  const deleteCircumstance = async (circumstance) => {
    await privateFetch(
      'DELETE',
      'prna',
      `/cu/${accountContext.id}/circumstance/${circumstance.id}/`,
      "L'actualité a bien été supprimée"
    ).then(() => {
      fetchCircumstanceList();
      setCircumstanceDetail(undefined);
    });
  };

  const handleClickCircumstance = (circumstance) => {
    openPRNACircumstanceDetail(circumstance);
  };

  useEffect(() => {
    if (navigationContext.acitveCircumstanceId) {
      fetchCircumstanceDetail();
    } else setCircumstanceDetail(undefined);
  }, [navigationContext]);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const goBackCircumstanceAction = {
    onClick: handleClickCircumstance,
    icon: 'pi-chevron-left',
    label: 'Retour à la liste'
  };

  const newCircumstanceAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une actualité',
    icon: 'pi-plus'
  };

  const handleCircumstanceOrderChange = async (circumstance, index) => {
    await privateFetch(
      'PUT',
      'prna',
      `/cu/${accountContext.id}/circumstance/${circumstance.id}/order/?index=${index}`
    ).then(() => {
      fetchCircumstanceList();
    });
  };

  const itemTemplate = (circumstance) => (
    <CircumstanceItem
      circumstance={circumstance}
      handleClickCircumstance={() => handleClickCircumstance(circumstance)}
      onChange={handleCircumstanceOrderChange}
    />
  );

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Actualités"
        labelAction={handleClickCircumstance}
        action={circumstanceDetail ? goBackCircumstanceAction : newCircumstanceAction}
        detail={circumstanceDetail}>
        {circumstanceDetail ? (
          <CircumstanceDetail
            circumstance={circumstanceDetail}
            handleUpdateCircumstance={handleOpenManager}
            handleDelete={deleteCircumstance}
          />
        ) : (
          <>
            <DataView value={circumstanceList} itemTemplate={itemTemplate} className="pb-20" />
          </>
        )}
      </PageWrapper>
      <CircumstanceManager
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        circumstance={circumstanceDetail}
        onCreate={createCircumstance}
        onUpdate={updateCircumstance}
        loading={loading}
      />
    </div>
  );
}

export default CircumstancePage;
